import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useSaveNotificationSettings = function useSaveNotificationSettings() {
  return useMutation(function (params) {
    return servicesUtils.postService("/profile/notifications/", params);
  });
};
export default useSaveNotificationSettings;